import React, { useState, useEffect } from "react";
import styles from "./channels.module.css";
import whatsApp from "src/assets/images/channels/Whatsapp.svg";
import website from "src/assets/images/channels/Website.svg";
import telegram from "src/assets/images/channels/Telegram.svg";
import instagram from "src/assets/images/channels/Instagram.svg";
import messanger from "src/assets/images/channels/Messanger.svg";
import ConnectJinniBotModal from "src/components/custom/modals/ConnectJinniBotModal";
import ConnecttelegramModal from "src/components/custom/modals/ConnectTelegramModal";
import DisconnectModel from "src/components/custom/modals/DisconnectModel";
import useConnectChannels from "../../connectChat/hooks/useConnectChannels";
import Loader from "src/layouts/loader/Loader";
import Axios from "src/utils/axios";
import LinkIcon from '@mui/icons-material/Link';
import waveEmoji from '../../../assets/images/channels/wave_icon.png'
import demo from '../../../assets/images/channels/demo.png'
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment";
import NoSubscriptionModal from "src/components/custom/modals/NoSubscriptionModal";
import Toast from "src/components/custom/Toast";

const svgPath =
  "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z";

const Channels = ({isAccountSetup}) => {
  const {
    showConnectModal,
    setShowConnectModal,
    showtelegrammodal,
    setshowtelegrammodal,
    showWhatsappmmodal,
    setshowWhatsappmodal,
    showFacebookmodal,
    setshowFacebookmodal,
    showInstagrammodal,
    setshowInstagrammodal,
    disconnectLoading,
    validIntegration,
    userdata,
    setUserdata,
    checkIntegration,
    launchInstagramSignup,
    LoginWithFacebook,
    launchWhatsAppSignup,
    disConnectFacebook,
    disConnectInstagram,
    disConnectWhatsapp,
    isLoading,
  } = useConnectChannels();


  const [open, setOpen] = useState(false);
  const [instOpen, setInstOpen] = useState(false);
  const [pageId, setPageId] = useState(null);
  const [FbOpen, setFbOpen] = useState(false);
  const [instLoading, setInstaLoading] = useState(false)
  const [isSubscried, setIsSubscribed] = useState(true);
  const Pagelist = ({ type }) => {

    const ConnectPage = (payload) => {
      setPageId(payload.page_id);
      Axios.post(`/${type === "instagram" ? "generateToken" : type}/${type}-page-subscribed`, payload)
        .then((res) => {
          setPageId(null);

          Axios.get("/user/getUserDetail")
            .then((res) => {
              setUserdata({
                integrationKeys: res.data.data.integrationKeys,
                subscription: res.data.data.subscription[0],
              });
              checkIntegration(res.data.data);
            })
            .catch((err) => { Toast(err, 'error');});
        })
        .catch((error) => {
          console.log(error, `${type}_login_error`);
          Toast(error, 'error');
        });
    };

    const DisconnectPage = (payload) => {
      setPageId(payload.page_id);
      Axios.post(`/${type === "instagram" ? "generateToken" : type}/${type}-page-unsubscribed`, payload)
        .then((res) => {
          setPageId(null);

          Axios.get("/user/getUserDetail")
            .then((res) => {
              setUserdata({
                integrationKeys: res.data.data.integrationKeys,
                subscription: res.data.data.subscription[0],
              });
              checkIntegration(res.data.data);
            })
            .catch((err) => { Toast(err, 'error')});
        })
        .catch((error) => {
          console.log(error, `${type}_login_error`);
          Toast(error, 'error');
        });
    };


    return (
      <div className={styles.connect_modal_wrapper + " mx-0 px-0 "}   >
        <div className={styles.modal_header}>
          <div className={styles.modal_left}>
            <h2>Connected Pages</h2>
          </div>
          <div className={styles.modal_right} onClick={() => {
            if (open) {
              setOpen(!open)
            } else {
              setInstOpen(!instagram)
            }
          }}>
            <CloseIcon />
          </div>
        </div>

        <div className={styles.drawer_body}>
          <div className={styles.records_wrapper}>
            <h5>Hello <img src={waveEmoji} /></h5>
            <p className="mb-4 ">
              {type === "facebook" && `We found ${userdata?.integrationKeys?.facebook?.pages?.length} Facebook  Page managed by you`}

              {type === "instagram" && `We found ${userdata?.integrationKeys?.instagram?.pages?.filter((pageItem) => pageItem.instagramId !== null).length} Facebook  Page managed by you`}
            </p>
          </div>
          {userdata?.integrationKeys?.[type]?.isActive &&
            userdata?.integrationKeys?.[type]?.pages?.map((pageItem) => {

              if (type === "instagram" && pageItem.instagramId !== null) {
                return <div className={styles.connected_wrapper + " d-flex align-items-center justify-content-between mb-3"}>
                  <div className="d-flex align-items-center  bg-white rounded  ">
                    <img

                      src={pageItem.picture || demo}
                      className="rounded-circle shadow-4-strong"
                      width={"40px"}
                      alt="facebook"
                    />
                    <p className="p-0 m-0  text-xs">{pageItem.name}</p>
                  </div>
                  <div>
                    <div

                      onClick={() => {
                        if (pageItem.connected) {
                          DisconnectPage({ page_id: pageItem.page_id })
                        }
                        else {
                          ConnectPage({ page_id: pageItem.page_id })
                        }
                      }}
                    >
                      <button className={pageItem.connected ? styles.connected_btn : styles.connect_btn}>
                        {pageItem.connected ? "Connected" : "Connect"}
                        {pageId === pageItem?.page_id && (
                          <img
                            src="/images/Reload.gif"
                            alt="loading"
                            style={{ width: "20px", height: "20px" }}
                            className="rounded-pill"
                          />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              }

              if (type === "facebook") {
                return <div className={styles.connected_wrapper + " d-flex align-items-center justify-content-between mb-3"}>
                  <div className="d-flex align-items-center  bg-white rounded  ">
                    <img

                      src={pageItem.picture || demo}
                      className="rounded-circle shadow-4-strong"
                      width={"40px"}
                      alt="facebook"
                    />
                    <p className="p-0 m-0  text-xs">{pageItem.name}</p>
                  </div>
                  <div>
                    <div
                      onClick={() => {
                        if (pageItem.connected) {
                          DisconnectPage({ page_id: pageItem.page_id })
                        }
                        else {
                          ConnectPage({ page_id: pageItem.page_id })
                        }
                      }}
                    >
                      <button className={pageItem.connected ? styles.connected_btn : styles.connect_btn}>
                        {pageItem.connected ? "Connected" : "Connect"}
                        {pageId === pageItem?.page_id && (
                          <img
                            src="/images/Reload.gif"
                            alt="loading"
                            style={{ width: "20px", height: "20px" }}
                            className="rounded-pill"
                          />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              }
            })}
        </div>
      </div>
    );
  };


  return (
    <section>
      <div className={isAccountSetup ? "" : "container"}>
        <div className="row">
          <div className="col-12 pt-4 pb-2">
            <h1 className={styles.integration_h1}>
              Seamless connection with all your favorite channels
            </h1>
            <p className={styles.integration_p}>
              Close more deals with PropertyJinni. Connect all your social media channels to manage leads and conversations in one place.         </p>
          </div>
        </div>
        {isLoading ? (
          <Loader />
        ) : (
          <div className="row">
            {open && <Pagelist type="facebook" />}

            <div className="col-md-4 px-2">
              <div className={styles.integration_card + " card"}>
                <div className={styles.card_header + " card-header"}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className={styles.integration_logo}>
                      <img src={website} alt="Website" className="img-fluid" />
                    </div>
                    <button
                      onClick={() => {
                        if (
                          userdata?._id &&
                          (!userdata?.subscription?.active ||
                            moment(userdata?.subscription?.endDate) < moment())
                        ) {
                          setIsSubscribed(false);
                        } else {
                          setShowConnectModal(true);
                        }

                      }}
                      className={
                        userdata?.integrationKeys.chatbot.isActive
                          ? styles.integration_btn_green
                          : styles.integration_btn
                      }
                      disabled={!validIntegration?.chatbot}
                    >
                      {/* <a href="javascript:void(0);"> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <path d={svgPath} />
                      </svg>
                      {userdata?.integrationKeys.chatbot.isActive
                        ? "Connected"
                        : "Connect"}
                      {/* </a> */}
                    </button>
                  </div>
                </div>
                <div className={styles.card_body}>
                  <h2>Website</h2>
                  <p>
                    Manage all website conversations in the PropertyJinni CRM.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 px-2">
              <div className={styles.integration_card + " card"}>
                <div className={styles.card_header + " card-header"}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className={styles.integration_logo}>
                      <img
                        src={whatsApp}
                        alt="WhatsApp"
                        className="img-fluid"
                      />
                    </div>
                    <button
                      className={
                        userdata?.integrationKeys.whatsapp.isActive
                          ? styles.integration_btn_green
                          : styles.integration_btn
                      }
                      onClick={() => {
                        if (
                          userdata?._id &&
                          (!userdata?.subscription?.active ||
                            moment(userdata?.subscription?.endDate) < moment())
                        ) {
                          setIsSubscribed(false);
                        } else {
                          if (userdata?.integrationKeys.whatsapp.isActive) {
                            setshowWhatsappmodal(true);
                          } else {
                            launchWhatsAppSignup();
                          }
                        }
                      }}
                      disabled={!validIntegration?.whatsapp}
                    >
                      {/* <a href="javascript:void(0);"> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <path d={svgPath} />
                      </svg>
                      {userdata?.integrationKeys.whatsapp.isActive
                        ? "Connected"
                        : "Connect"}
                      {/* </a> */}
                    </button>
                  </div>
                </div>
                <div className={styles.card_body}>
                  <h2>WhatsApp</h2>
                  <p>Manage your chats on WhatsApp within the PropertyJinni CRM. </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 px-2">
              <div className={styles.integration_card + " card"}>
                <div className={styles.card_header + " card-header"}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className={styles.integration_logo}>
                      <img
                        src={messanger}
                        alt="Messenger"
                        className="img-fluid"
                      />
                    </div>
                    <button
                      className={
                        userdata?.integrationKeys.facebook.isActive
                          ? styles.integration_btn_green
                          : styles.integration_btn
                      }
                      onClick={() => {
                        if (
                          userdata?._id &&
                          (!userdata?.subscription?.active ||
                            moment(userdata?.subscription?.endDate) < moment())
                        ) {
                          setIsSubscribed(false);
                        } else {
                          if (userdata?.integrationKeys.facebook.isActive) {
                            setFbOpen(false);
                            setshowFacebookmodal(true);
                          } else {
                            setFbOpen(true);
                            LoginWithFacebook();
                          }
                        }

                      }}
                      disabled={!validIntegration?.facebook}
                    >
                      {/* <a href="javascript:void(0);"> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <path d={svgPath} />
                      </svg>
                      {userdata?.integrationKeys.facebook.isActive
                        ? "Connected"
                        : "Connect"}
                      {/* </a> */}
                      {FbOpen &&
                        userdata?.integrationKeys.facebook.isActive ===
                        false && (
                          <img
                            src="/images/Reload.gif"
                            alt="loading"
                            style={{ width: "20px", height: "20px" }}
                            className="rounded-pill"
                          />
                        )}
                    </button>
                  </div>
                </div>
                <div className={styles.card_body}>
                  <h2>Facebook Messenger</h2>
                  <p>
                    Utilise PropertyJinni CRM to manage your Facebook Messenger
                    conversations.

                    {userdata?.integrationKeys?.facebook?.isActive && (
                      <a
                        onClick={() => {
                          setInstOpen(false);
                          setOpen(!open)
                        }}
                        className={styles.linked_pages + " d-block"}
                      >
                        <LinkIcon />View Linked Page
                      </a>
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 px-2">
              {instOpen && <Pagelist type="instagram" />}
              <div className={styles.integration_card + " card"}>
                <div className={styles.card_header + " card-header"}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className={styles.integration_logo}>
                      <img
                        src={instagram}
                        alt="Instagram"
                        className="img-fluid"
                      />
                    </div>
                    <button
                      className={
                        userdata?.integrationKeys.instagram.isActive
                          ? styles.integration_btn_green
                          : styles.integration_btn
                      }
                      onClick={() => {
                        if (
                          userdata?._id &&
                          (!userdata?.subscription?.active ||
                            moment(userdata?.subscription?.endDate) < moment())
                        ) {
                          setIsSubscribed(false);
                        } else {
                          if (userdata?.integrationKeys.instagram.isActive) {
                            setInstaLoading(false)
                            setshowInstagrammodal(true);
                          } else {
                            setInstaLoading(true)
                            launchInstagramSignup();
                          }
                        }

                      }}
                      disabled={!validIntegration?.instagram}
                    >

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <path d={svgPath} />
                      </svg>
                      {userdata?.integrationKeys.instagram.isActive
                        ? "Connected"
                        : "Connect"}
                      {instLoading &&
                        userdata?.integrationKeys.instagram.isActive ===
                        false && (
                          <img
                            src="/images/Reload.gif"
                            alt="loading"
                            style={{ width: "20px", height: "20px" }}
                            className="rounded-pill"
                          />
                        )}

                    </button>
                  </div>
                </div>
                <div className={styles.card_body}>
                  <h2>Instagram</h2>
                  <p>
                    Manage your Instagram conversations using the PropertyJinni
                    CRM.
                  </p>
                  {userdata?.integrationKeys?.instagram?.isActive && (
                    <a
                      onClick={() => {
                        setOpen(false)
                        setInstOpen(!instOpen)
                      }}
                      className={styles.linked_pages + " d-block"}
                    >
                      <LinkIcon />View Linked Page
                    </a>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-4 px-2">
              <div className={styles.integration_card + " card"}>
                <div className={styles.card_header + " card-header"}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className={styles.integration_logo}>
                      <img
                        src={telegram}
                        alt="Telegram"
                        className="img-fluid"
                      />
                    </div>
                    <button
                      className={
                        userdata?.integrationKeys.telegram.isActive
                          ? styles.integration_btn_green
                          : styles.integration_btn
                      }
                      onClick={() => {
                        if (
                          userdata?._id &&
                          (!userdata?.subscription?.active ||
                            moment(userdata?.subscription?.endDate) < moment())
                        ) {
                          setIsSubscribed(false);
                        } else {
                          setshowtelegrammodal(true);
                        }

                      }}
                      disabled={!validIntegration?.telegram}
                    >
                      {/* <a href="javascript:void(0);"> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <path d={svgPath} />
                      </svg>
                      {userdata?.integrationKeys.telegram.isActive
                        ? "Connected"
                        : "Connect"}
                      {/* </a> */}
                    </button>
                  </div>
                </div>
                <div className={styles.card_body}>
                  <h2>Telegram</h2>
                  <p>
                    Manage all of your Telegram conversations within the
                    PropertyJinni CRM.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="p-0">
        <ConnectJinniBotModal
          open={showConnectModal}
          closeModal={() => setShowConnectModal(false)}
          setUserdata={setUserdata}
          userdata={userdata}
          checkIntegration={checkIntegration}
        />
      </div>
      <div className="p-0">
        <ConnecttelegramModal
          open={showtelegrammodal}
          closeModal={() => setshowtelegrammodal(false)}
          setUserdata={setUserdata}
          userdata={userdata}
          checkIntegration={checkIntegration}
        />
      </div>
      <div className="p-0">
        <DisconnectModel
          open={showFacebookmodal}
          closeModal={() => setshowFacebookmodal(false)}
          handleDelete={disConnectFacebook}
          text={"facebook"}
          isLoading={disconnectLoading}
        />
      </div>
      <div className="p-0">
        <DisconnectModel
          open={showInstagrammodal}
          closeModal={() => setshowInstagrammodal(false)}
          handleDelete={disConnectInstagram}
          text={"instagram"}
          isLoading={disconnectLoading}
        />
      </div>
      <div className="p-0">
        <DisconnectModel
          open={showWhatsappmmodal}
          closeModal={() => setshowWhatsappmodal(false)}
          handleDelete={disConnectWhatsapp}
          text={"whatsapp"} n
          isLoading={disconnectLoading}
        />
      </div>
      {!isSubscried && <NoSubscriptionModal userdata={userdata} />}
    </section>
  );
};

export default Channels;
